// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2mNye","right":"styles_right__3a4ot"};